export default __webpack_public_path__ + "static/media/경기.12032740.png";